import { z } from 'zod';

export const defaultDirectoryPageSize = 20;
export const directoryQuery = z.object({
    search: z.string().trim().max(200).default(''),
    page: z.coerce.number().int().min(1).max(100000).default(1),
    pageSize: z.coerce.number().int().min(1).max(100).default(defaultDirectoryPageSize),
});
export const organizationInput = z.object({
    name: z.string().trim().min(1).max(200),
    slug: z
        .string()
        .trim()
        .min(1)
        .max(100)
        .regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/),
});
export const organizationParams = z.object({ organizationId: z.uuid() });
export const access = z.object({ administrator: z.boolean(), products: z.array(z.string()) });
export type Access = z.infer<typeof access>;
export const directoryUser = z.object({
    id: z.uuid(),
    name: z.string(),
    email: z.string(),
    administrator: z.boolean(),
    memberships: z.number().int(),
    createdAt: z.iso.datetime(),
});
export type DirectoryUser = z.infer<typeof directoryUser>;
export const directoryOrganization = z.object({
    id: z.uuid(),
    name: z.string(),
    slug: z.string(),
    members: z.number().int(),
    createdAt: z.iso.datetime(),
});
export type DirectoryOrganization = z.infer<typeof directoryOrganization>;
export const productAccess = z.object({ productId: z.string(), enabled: z.boolean() });
export type ProductAccess = z.infer<typeof productAccess>;
export const pageOf = <T extends z.ZodType>(item: T) => z.object({ items: z.array(item), total: z.number().int() });
export type DirectoryPage<T> = { items: T[]; total: number };
